import { BASE_URL } from "../BaseUrl.js";
import axios from "axios";

axios.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("compte_admin");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      config.headers.Authorization = null;
    }

    return config;
  },
  function (error) {
    console.log("AN ERROR REQUEST", error);
  }
);

//liste des Marques

export const listeDesMarques = async (page, size, param) => {
  // return await axios.get(`${BASE_URL}/parametres/allMarque`), {});
  return await axios.get(
    `${BASE_URL}/parametrage/Marque/all?page=${page}&size=${size}&param=${param}`,
    {}
  );
};

//liste Marque sans filters
export const listeMarquesSansFiltre = async () => {
  // return await axios.get(`${BASE_URL}/parametres/allMarque`), {});
  return await axios.get(`${BASE_URL}/parametrage/Marque/allMarques`, {});
};

// Enregiste des Marques

export const enregistrerMarques = async (Marques) => {
  return await axios.post(`${BASE_URL}/parametrage/Marque`, Marques);
};

// modifie Marque

export const modifierMarqueById = async (MarqueId, Marque) => {
  return await axios.put(
    `${BASE_URL}/parametrage/Marque/${MarqueId}`,
    Marque
  );
};

// supprimer une Marque

export const supprimerUneMarque = async (MarqueId) => {
  return await axios.delete(`${BASE_URL}/parametrage/Marque/${MarqueId}`);
};
